import { Component } from "@angular/core";

@Component({
    selector: "info",
    templateUrl: "./info.component.html",
    standalone: false,
})
export class InfoComponent { }
